import * as React from 'react'
import { ComponentPropsWithRef, HTMLInputTypeAttribute, useState } from 'react'
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'
import { MdVisibility, MdVisibilityOff } from 'react-icons/md'
import AlertIcon from '../../assets/svgIcons/AlertIcon'
import CheckIcon from '../../assets/svgIcons/CheckIcon'
import './styles.scss'

interface InputProps extends ComponentPropsWithRef<'input'> {
  name?: string
  variant: 'light' | 'dark' | 'light-normal' | 'light-normal-check'
  type?: HTMLInputTypeAttribute
  readOnly?: boolean
  errors?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined
  money?: boolean
  percentage?: boolean
  icon?: boolean
  onValueInput?: () => void
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input({
  variant,
  readOnly = false,
  type = 'text',
  money = false,
  errors,
  onValueInput,
  percentage = false,
  icon = true,
  ...rest
}, ref) {
  const [showPass, setShowPass] = useState<boolean>(false)

  const handleFieldType = (): string => {
    return type === 'password' ? (showPass ? 'text' : 'password') : type
  }

  const showPassToggle = (): void => {
    setShowPass(!showPass)
  }

  const showPassToggleContent = () => {
    return (
      type === 'password' && (
        <div onClick={showPassToggle}>
          {!showPass ? <MdVisibility /> : <MdVisibilityOff />}
        </div>
      )
    )
  }

  const showCheckIcon = () => {
    return (
      <div className={variant} onClick={onValueInput}>
        <CheckIcon width="30" height="20" fill="#048243" />
      </div>
    )
  }

  const showAlertIcon = () => {
    return (
      errors &&
      icon && (
        <div className="container-alert-icon">
          <AlertIcon width="20" height="20" fill="#c21618" />
        </div>
      )
    )
  }

  return (
    <>
      <div
        className={`input-container input-${variant} ${
          errors && 'input-error'
        } ${readOnly && 'read-only'}`}
      >
        {money && <span>R$</span>}
        {percentage && <span>%</span>}
        <input {...rest} {...{ref}} type={handleFieldType()} />
        {showCheckIcon()}
        {showAlertIcon()}
        {showPassToggleContent()}
      </div>
      <div className="span-error-container">
        {errors?.message && (
          <span className="input-error-span">{errors.message.toString()}</span>
        )}
      </div>
    </>
  )
})
